import { Upload } from '@aws-sdk/lib-storage';
import { S3 } from '@aws-sdk/client-s3';

const uploadFileToS3 = async (file, filekey, onProgress) => {
  const s3 = new S3({
    region: process.env.NEXT_PUBLIC_AWS_REGION,
    credentials: {
      accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY
    }
  });

  const params = {
    Bucket: process.env.NEXT_PUBLIC_AWS_BUCKET,
    Key: filekey,
    Body: file
  };

  if (filekey.startsWith('Documents')) {
    params.ContentType = file.type;
  }

  const uploadRes = await new Upload({
    client: s3,
    params
  }).on('httpUploadProgress', (evt) => {
    const progress = Math.round((evt.loaded / evt.total) * 100);
    onProgress(progress);
  })
    .done((err) => {
      if (err) {
        console.error('Upload error', { err });
        return;
      }
      console.log('Upload success');
    });
  return uploadRes;
};

export default uploadFileToS3;
